// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/buttons/buttons.scss
 ** module id = 24
 ** module chunks = 0 1
 **/